module.exports = __webpack_public_path__ + "img/encina-min.f5aa1107.png";